@if (this.loader.getLoading()) {
  <app-loader></app-loader>
}
<!--
  Lien d'evitement et repere principal : cet ecran n'en avait aucun, comme la
  page de connexion. Releve par un pre-audit RGAA outille sur les routes
  PUBLIQUES -- les mesures manuelles de la campagne portaient sur les ecrans
  authentifies, ou le lien vit dans la coquille `pages.component`.
-->
<app-lien-evitement />

<!--
  `<main>` et non `<div>` : la classe porte toujours le style, la balise apporte
  le repere (RGAA 12.6). `tabindex="-1"` la rend focalisable par programme sans
  l'inserer dans l'ordre de tabulation, ce qui permet au lien d'y poser le focus.
-->
<main
  class="reset-password-container dflex aic jcc"
  id="contenu-principal"
  tabindex="-1"
>
  @if (!sent) {
    <!-- `alt=""` et non `alt="decorative"` : le mot etait lu a voix haute
         comme NOM de l'image. Une image de decoration s'ignore par une
         alternative VIDE (RGAA 1.2). -->
    <img src="/assets/images/reset-password-left.svg" alt="" />
    <form class="reset-password-form" [formGroup]="formGroup">
      <!--
        `<h1 class="h2">` : le NIVEAU est semantique, la TAILLE est visuelle, et
        le depot fournit `.h2` pour les separer. La page n'avait aucun titre de
        niveau 1 -- son premier titre etait un `h2` (RGAA 9.1) -- et l'apparence
        ne change pas, la classe (0,1,0) l'emportant sur la balise (0,0,1).
      -->
      <h1 class="h2">
        {{ 'LOGIN.FORM.PASSWORD.RESET_PASSWORD' | translate }}
      </h1>
      <span>{{ 'LOGIN.FORM.PASSWORD.RESET_PASSWORD_TEXT' | translate }}</span>
      <div>
        <label for="email" class="fs12"
          >{{ 'LOGIN.FORM.EMAIL.LABEL' | translate }} *:</label
        >
        <app-string-field
          [label]="'LOGIN.FORM.EMAIL.LABEL' | translate"
          placeholder="exemple@exemple.com"
          controlName="email"
          controlId="email"
          type="email"
          [required]="true"
          [submitted]="submitted"
          [formGroup]="formGroup"
        ></app-string-field>
      </div>
      <div class="btn-cont dflex jcsb">
        <a
          class="hub-button hub-button--ghost hub-button--large"
          routerLink="/login"
        >
          {{ 'BUTTON.CANCEL' | translate }}
        </a>
        <button
          class="hub-button hub-button--primary hub-button--large"
          (click)="onSubmit()"
        >
          {{ 'LOGIN.FORM.PASSWORD.RESET_THE_PASSWORD' | translate }}
        </button>
      </div>
    </form>
  } @else {
    <div class="dflex fdc aic jcc">
      <img src="/assets/images/mail-sent.svg" alt="" />
      <div class="mail-sent-cont">
        <!-- `aria-hidden` : sans lui, la ligature de la police d'icones est
             annoncee telle quelle -- « check » -- a la suite du titre. -->
        <span class="material-symbols-rounded icon" aria-hidden="true"
          >check</span
        >
        <!-- Les deux branches de `@if` sont EXCLUSIVES : l'etat « envoye »
             est une page a part entiere du point de vue des titres, et il lui
             faut donc son propre niveau 1. -->
        <h1 class="h2">{{ 'TOASTR.EMAIL_SEND' | translate }} !</h1>
        <p>
          {{ 'LOGIN.FORM.PASSWORD.RESET_PASSWORD_EMAIL_SENT_TEXT' | translate }}
        </p>
      </div>
    </div>
  }
</main>
